import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Copy } from 'lucide-react';

export const SaveAsTemplateDialog = ({
  saveAsTemplate,
  setSaveAsTemplate,
  savingTemplate,
  handleSaveAsTemplate,
  formatCurrency,
}) => (
  <Dialog open={!!saveAsTemplate} onOpenChange={(open) => { if (!open) setSaveAsTemplate(null); }}>
    <DialogContent className="sm:max-w-md border border-zinc-200 rounded-none p-0" data-testid="save-as-template-dialog">
      <DialogHeader className="p-5 pb-0">
        <DialogTitle className="text-xl font-heading font-bold uppercase tracking-wide">Save as Template</DialogTitle>
      </DialogHeader>
      {saveAsTemplate && (
        <div className="p-5 space-y-4">
          <p className="text-xs text-zinc-500">
            Reusable for future orders. Captures vendor, line items, tax, and freight.
          </p>

          <div>
            <label className="block text-[10px] font-heading font-bold uppercase tracking-wider text-zinc-500 mb-1">Template Name</label>
            <input
              type="text"
              value={saveAsTemplate.name}
              onChange={(e) => setSaveAsTemplate({ ...saveAsTemplate, name: e.target.value })}
              data-testid="save-template-name-input"
              className="w-full h-10 px-3 border-2 border-black bg-white text-sm font-medium focus:outline-none focus:border-primary"
              placeholder="e.g. 20A Panel Starter Kit"
              autoFocus
            />
          </div>

          <div>
            <label className="block text-[10px] font-heading font-bold uppercase tracking-wider text-zinc-500 mb-1">Category</label>
            <select
              value={saveAsTemplate.category}
              onChange={(e) => setSaveAsTemplate({ ...saveAsTemplate, category: e.target.value })}
              data-testid="save-template-category-select"
              className="w-full h-10 px-3 border-2 border-black bg-white text-sm font-bold uppercase"
            >
              <option value="general">General</option>
              <option value="electrical">Electrical</option>
              <option value="plumbing">Plumbing</option>
              <option value="hvac">HVAC</option>
              <option value="mechanical">Mechanical</option>
            </select>
          </div>

          <div>
            <label className="block text-[10px] font-heading font-bold uppercase tracking-wider text-zinc-500 mb-1">Description <span className="text-zinc-400 normal-case">(optional)</span></label>
            <textarea
              value={saveAsTemplate.description}
              onChange={(e) => setSaveAsTemplate({ ...saveAsTemplate, description: e.target.value })}
              data-testid="save-template-description-input"
              rows={2}
              className="w-full px-3 py-2 border-2 border-black bg-white text-sm focus:outline-none focus:border-primary resize-none"
              placeholder="What is this template for?"
            />
          </div>

          {/* Preview */}
          <div className="bg-zinc-50 border border-zinc-200 p-3">
            <p className="text-[10px] font-heading font-bold uppercase tracking-wider text-zinc-500 mb-1">Included</p>
            <div className="text-xs space-y-0.5">
              <p><span className="font-mono text-zinc-500">Vendor:</span> <span className="font-semibold">{saveAsTemplate.order.vendor_name || '—'}</span></p>
              <p><span className="font-mono text-zinc-500">Line items:</span> <span className="font-semibold">{saveAsTemplate.order.line_items?.length || 0}</span></p>
              <p><span className="font-mono text-zinc-500">Tax:</span> <span className="font-semibold">{formatCurrency(saveAsTemplate.order.tax || 0)}</span></p>
              <p><span className="font-mono text-zinc-500">Freight:</span> <span className="font-semibold">{formatCurrency(saveAsTemplate.order.freight || 0)}</span></p>
              <p><span className="font-mono text-zinc-500">Total:</span> <span className="font-semibold">{formatCurrency(saveAsTemplate.order.total || 0)}</span></p>
            </div>
          </div>

          <div className="flex gap-2 pt-2">
            <button
              onClick={() => setSaveAsTemplate(null)}
              data-testid="save-template-cancel-btn"
              className="flex-1 h-10 bg-white text-zinc-900 font-bold uppercase border-2 border-black hover:bg-zinc-100"
            >
              Cancel
            </button>
            <button
              onClick={handleSaveAsTemplate}
              disabled={savingTemplate || !saveAsTemplate.name.trim()}
              data-testid="save-template-confirm-btn"
              className="flex-1 h-10 bg-primary text-zinc-900 font-bold uppercase border-2 border-black hover:bg-primary-hover disabled:opacity-50 flex items-center justify-center gap-2"
            >
              <Copy className="w-4 h-4" />
              {savingTemplate ? 'Saving...' : 'Save Template'}
            </button>
          </div>
        </div>
      )}
    </DialogContent>
  </Dialog>
);
